import React from 'react';
import {withTranslation} from 'react-i18next';
import history from "../../utils/History";
import Spinner from "../../components/spinner/Spinner";
import SegnalazioniService from "../../services/SegnalazioniServices";
import Utils from "../../utils/Utils";
import ToasterSingleton from "../../singleton/ToasterSingleton";
import toasterConfig from "../../config/toasterConfig";

class Manuali extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        SegnalazioniService.getManuali(this.props.location.id)
            .then((res)=>{
                if (res.status===200){
                    Utils.downloadReport(res.data.file.data,res.data.nome,"pdf")
                }
            })
            .catch(() => {
                this.setState({loading: false})
                return this.aggiungiToaster("Non sono presenti manuali");
            });
        history.push({
            pathname: "/home",
        });
    }

    aggiungiToaster(text) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now()
        })
    }

    render() {
        return (
            <div >
                <Spinner/>
            </div>
        )
    }
}

export default withTranslation('common')(Manuali);
